import { useEffect, useState, useRef } from "react";
import ReactPlayer from 'react-player';
import { Player } from 'video-react';
import VideoThumbnail from 'react-video-thumbnail';
import "video-react/dist/video-react.css"; // import the default styles
import React from "react";
import { useNavigate } from 'react-router-dom';
import {ReactComponent as SearchIcon } from "../assets/serch-icon.svg";
import axios from 'axios';
import {ReactComponent as ClIcon} from '../assets/close-icon.svg';
import {ReactComponent as SIcon} from '../assets/save-icon.svg';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import "../App.css";
const containerStyle = {
  width: '100%',
  height: '100%'
};
const Details = () =>{
    const [uMachines, setUmachines] = useState(false);
    const [showIcon, setShowIcon] = useState(true);
    const [uMap, setUMap] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [machines ,setMachines] = useState([]);
    const [multipleSelection, setMultipleSelection] = useState(false);
    const [selectedMachines, setSelectedMachines] = useState(new Set());
    const [selectedName, setSelectedname] = useState(new Set());
    const [userD ,setUserD] = useState(null);
    const [superU, setSuperU] = useState(false);
    const [allU,setAllU] = useState([]);
    const [addUs ,setAddUs] = useState(false);
    const [userList ,setUserList] = useState(true);
    const [aMach, setAMach] = useState(false);
    const [nMUId, setNMUId] = useState();
    const [nMName, setNMName] = useState("");
    const [nMLat, setNMLat] = useState("");
    const [nMlong, setNMlong] = useState("");
    const [nMType, setNMType] = useState("");
    const [blshad, setBlshad] = useState(false);
    const [supp, setSupp] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null); 
    const [hoveredMachine, setHoveredMachine] = useState(null);
    const [formData, setFormData] = useState({
      name: '',
      email: '',
      password: '',
      role: '',
      image: null,
  });
  const[nUName, setNUName] = useState('');
  const[nUEmail, setNUEmail] = useState('');
  const[nUImg, setNUImg] = useState('');
  const[nUPass, setNUPass] = useState('');
  const[nURole, setNURole] = useState();
  const [naMUId, setNaMUId] = useState("")
    const navigate = useNavigate();


    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const [classWidth, setClassWidth] = useState(0);
    const [classHeight, setClassHeight] = useState(0);
    const [selectedUser, setSelectedUser] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [snglM, setSnglM] = useState([]);
    const [noMachinesMessage, setNoMachinesMessage] = useState("");
    const [users, setUsers] = useState([]);
    const [allMachines, setAllMachines] = useState([]);
    const [mdata, setMData] = useState("");
    const [showUsers, setShowUsers] = useState(false);
    const [selUNM, setSelUNM] = useState("");
    const [selMacId, setSelMacId] = useState();
    const [hoverMName, setHoverMName] = useState("");
    const [hoverMId, setHoverMId] = useState();
    const [hoverMUid, setHoverMUid] = useState();
                          // nov task
    const [gide, setGide] = useState(false);
    const [selectedFile2, setSelectedFile2] = useState(null);
    const [videos, setVideos] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [selectedVideo2, setSelectedVideo2] = useState(null);
    const [contextMenu, setContextMenu] = useState(null);
    const [nowPName, setNowPName] = useState("");
    const [spTkn, setSpTkn] = useState("");
    const [videoUrl, setVideoUrl] = useState(null);
    const [thumbnailUrls, setThumbnailUrls] = useState({}); 

    const [otp, setOtp] = useState("");
    const [step, setStep] = useState("FORM"); // FORM | OTP
    const [loading, setLoading] = useState(false);
    const fetchCsrfToken = async () => {
      const res = await axios.get("/api/csrf-token", {
        withCredentials: true
      });
      return res.data.csrfToken;
    };
    useEffect(() => {
      const userDataString = sessionStorage.getItem('userData');
      
      if (userDataString) {
          const userData = JSON.parse(userDataString);
          setUserD(userData);
      }
  }, []);
  useEffect(() => {
    // console.log(userD," This is user details from details page.");
    
    if (userD?.role_id === 1) {
      setSuperU(true);
    }
}, [userD]);
// Default center and bounds
const [center, setCenter] = useState({
  lat: 52.370216,  // Default latitude
  lng: 4.895168    // Default longitude
});
const fetchMachines = async () => {
  try {
    // Get userData from sessionStorage
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    if (!userData || !userData.id) {
      throw new Error('User ID not found in session storage');
    }
    const userId = userData.id;
    // Call API without userId in query (backend will get it from token)
    const response = await axios.get(`/api/machines?userId=${userId}`, {
      withCredentials: true
    });

    const machines = response.data;
    setMachines(machines);

    // If there's machine data, calculate the map center and bounds
    if (machines.length > 0) {
      const latitudes = machines.map(machine => parseFloat(machine.latitude)); // Assuming 'latitude' field in response
      const longitudes = machines.map(machine => parseFloat(machine.longitude)); // Assuming 'longitude' field in response
      //  console.log("This si type of log and lat ",typeof(latitudes[1]), typeof(longitudes[1]));
       
      // Calculate the bounds
      const minLat = Math.min(...latitudes);
      const maxLat = Math.max(...latitudes);
      const minLng = Math.min(...longitudes);
      const maxLng = Math.max(...longitudes);

      // Set the map center to the midpoint of the bounds
      const centerLat = (minLat + maxLat) / 2;
      const centerLng = (minLng + maxLng) / 2;
      // console.log("type of cant lat and log ",typeof(centerLat),typeof(centerLng));
      
      const newCenter = {
        lat: centerLat,
        lng: centerLng
      };
      setCenter({
        lat: centerLat,
        lng: centerLng
      });

      // Calculate the zoom or bounds for the map (assuming a map library like Google Maps)
      const bounds = {
        north: maxLat,
        south: minLat,
        east: maxLng,
        west: minLng
      };
    }
  } catch (error) {
    console.error('Error fetching machines:', error);
  }
};




    useEffect(() => {
  let userData = sessionStorage.getItem('userData');
  // console.log(userData);
  let super2 = sessionStorage.getItem('super');
  if(super2 === 'true'){
    setSupp(true);
  }else{
    setSupp(false);
  }
  // console.log(super2 +" This is super user log");
      const updateDimensions = () => {
        const newWidth = window.innerWidth;
        const newHeight = window.innerHeight;
        
        const newClassWidth = 0.95*newWidth;
        const newClassHeight = newClassWidth*0.75;
        setClassHeight(newClassHeight);
        setClassWidth(newClassWidth);
      };
  
      // Add event listener for resize event
      window.addEventListener('resize', updateDimensions);
  
      // Initial log
      updateDimensions();
  
      // Cleanup function to remove the event listener
      return () => {
        window.removeEventListener('resize', updateDimensions);
      };
    }, []);

    useEffect(() => {
        const userDataString = sessionStorage.getItem('userData');
        if (!userDataString) {
            // If session data is not found, navigate to the homepage
            navigate('/');
        }
        fetchMachines();
        getUsers();
    }, [navigate]);
    // const turnDashboard = () =>{
    //     navigate('/Dashboard');
    // }
const turnDashboard = () => {
    // Retrieve existing userData from sessionStorage
  let userData = sessionStorage.getItem('userData');
  userData = userData ? JSON.parse(userData) : {};

  // Update userData to set selectedMachineIds to an empty array
  userData.selectedMachineIds = [];
  userData.selectedName = [];
  // Store the updated userData back in sessionStorage
  sessionStorage.setItem('userData', JSON.stringify(userData));

  // Navigate to the Dashboard
  // navigate('/Dashboard');
  window.location.reload();
};

const turnMachines = () =>{
  setUmachines(true);
  setUMap(false);
  setGide(false)
  fetchMachines();
}
const turnMap = () =>{
  setUmachines(false);
  setUMap(true);
  setGide(false)
  fetchMachines();
}
const turnGide = () =>{
  setUmachines(false);
  setUMap(false);
  setAMach(false);
  setAddUs(false);
  setUserList(false);
  setGide(true)
  fetchMachines();
}
const fetchUsers = async () => {
  try {
    const response = await axios.get("/api/users", {
      withCredentials: true
    });
    setAllU(response.data);
    setUsers(response.data);
  } catch (error) {
    console.error('Error fetching Users:', error.response?.data || error.message);
  }
};
const getUsers = async () =>{
    setAMach(false);
    setAddUs(false);
    setUserList(true);
    setGide(false);
    fetchUsers();
  }

  // if(machines){
  //   console.log(machines);
  // }
  const handleCheckboxChange = (id, name) => {
    // alert(name);
    setSelectedMachines(prev => {
        const newSelection = new Set(prev);
        if (newSelection.has(id)) {
            newSelection.delete(id);
        } else {
            newSelection.add(id);
        }
        return newSelection;
    });
    setSelectedname(prev => {
      const newname = new Set(prev);
      if (newname.has(name)) {
          newname.delete(name);
      } else {
          newname.add(name);
      }
      return newname;
  });
};
const handleMachineClick = (id,name, e) => {
  // If the click is on a checkbox, do not toggle row selection
  // alert(id+" "+name);
  if (e.target.type === 'checkbox') return;

  if (!multipleSelection) {
      // console.log({ id, user_id });

      // Retrieve existing userData from sessionStorage
      let userData = sessionStorage.getItem('userData');
      userData = userData ? JSON.parse(userData) : {};

      // Replace selectedMachineIds with the new ID
      userData.selectedMachineIds = [id];
      userData.selectedName=[name];
      // Store the updated userData back in sessionStorage
      sessionStorage.setItem('userData', JSON.stringify(userData));
      navigate('/Dashboard');
      window.location.reload();
  }
};
const handleGoClick = () => {
  const user_id = machines[0]?.user_id; // Assuming all machines have the same user_id
  const selectedMachineIds = Array.from(selectedMachines);
  const selectedNames = Array.from(selectedName);
  // Retrieve existing userData from sessionStorage
  let userData = sessionStorage.getItem('userData');
  userData = userData ? JSON.parse(userData) : {};

  // Update userData with selectedMachineIds
  userData.selectedMachineIds = selectedMachineIds;
  userData.user_id = user_id;
  userData.selectedName = selectedNames;
  // Store the updated userData back in sessionStorage
  sessionStorage.setItem('userData', JSON.stringify(userData));

  // Log the updated userData for confirmation
  // console.log('Updated userData in sessionStorage from multiple:', userData);
  navigate('/Dashboard');
  window.location.reload();
};
const getuserdetails = (e) =>{
  // alert(e.id);
  let userData = sessionStorage.getItem('userData');
  userData = userData ? JSON.parse(userData) : {};
  let user_id = e.id;
  userData.user_id = user_id;
  userData.id = user_id;
  userData.role_id = 2
  // Store the updated userData back in sessionStorage
  sessionStorage.setItem('userData', JSON.stringify(userData));

  // Log the updated userData for confirmation
  // console.log('Updated userData in sessionStorage from multiple:', userData);
  setSuperU(false);
  fetchMachines();
  window.location.reload();
}
const backSuperU = () =>{
  let userData = sessionStorage.getItem('userData');
  userData = userData ? JSON.parse(userData) : {};
  userData.role_id = 1
  // Store the updated userData back in sessionStorage
  sessionStorage.setItem('userData', JSON.stringify(userData));
  setSuperU(true);
  fetchMachines();
}
const addUser = () =>{
  setAddUs(true);
  setUserList(false);
  setAMach(false);
  setGide(false);
}
const addMachine = () =>{
  setAddUs(false);
  setUserList(false);
  setAMach(true);
  setGide(false);
  fetchUsers();
}
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevData) => ({
      ...prevData,
      [name]: value,
  }));
};

const handleFileChange = (e) => {
  const file = e.target.files[0];
  setFormData((prevData) => ({
      ...prevData,
      image: file,
  }));
};
useEffect(() => {
localStorage.setItem("activeTab", "home");
  if (formData) {
    setNUName(formData.name);
    setNUEmail(formData.email);
    setNUPass(formData.password);
    setNUImg(formData.image);
    setNURole(formData.role);
  }
}, [formData]); // This effect runs when formData changes

// const handleSubmit = (e) => {
//   e.preventDefault();

//   if (nUName === '' || nUEmail === ''|| nUPass === '' || nURole === '') {
//     alert("All fields except the image are required.");
//     return;
//   }

//   const formData = new FormData();
//   formData.append('name', nUName);
//   formData.append('email', nUEmail);
//   formData.append('password', nUPass);
//   formData.append('role', nURole);
//   formData.append('image', nUImg);  // Append the image file
//   // console.log(nUName,nUEmail, nUPass , nURole, nUImg, "this is form data to upload");
//   fetch("/api/adduser", {
//     credentials: "include",
//     method: "POST",
//     body: formData,
//   })
//     .then(response => response.json())
//     .then(data => {
//       alert(data.message);
//       setFormData({ name: '', email: '', password: '', role: '', image: null });
//     })
//     .catch((error) => {
//       console.error('Error:', error);
//     });
// };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!nUName || !nUEmail || !nUPass || !nURole) {
    alert("All fields except the image are required.");
    return;
  }

  try {
    setLoading(true);

    // CSRF token
    const csrfToken = await fetchCsrfToken();

    // reCAPTCHA
    if (!window.grecaptcha) throw new Error("reCAPTCHA not loaded");
    const captchaToken = await window.grecaptcha.execute(
      "6LeqJy4sAAAAAIza9IFp_p2MvE4MzDZiEFc98dYT",
      { action: step === "FORM" ? "adduser" : "adduser_verify" }
    );

    let url = "/api/adduser";
    let body;

    // 🟢 STEP 1 — SEND OTP
    if (step === "FORM") {
      body = new FormData();
      body.append("name", nUName);
      body.append("email", nUEmail);
      body.append("password", nUPass);
      body.append("role", nURole);
      if (nUImg) body.append("image", nUImg);
      body.append("captchaToken", captchaToken);
    }

    // 🔐 STEP 2 — VERIFY OTP
    if (step === "OTP") {
      if (!otp.trim()) {
        alert("OTP is required");
        return;
      }

      url = "/api/adduser-verify-otp";
      body = JSON.stringify({
        otp,
        captchaToken
      });
    }

    const res = await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        "X-CSRF-Token": csrfToken,
        ...(step === "OTP" && { "Content-Type": "application/json" })
      },
      body
    });

    const data = await res.json();

    if (!res.ok) throw new Error(data.message);

    // 🔁 OTP sent
    if (data.step === "OTP_SENT") {
      alert("OTP sent to your email");
      setStep("OTP");
      return;
    }

    // ✅ User created
    alert("User added successfully");
    setFormData({ name: "", email: "", password: "", role: "", image: null });
    setOtp("");
    setStep("FORM");

  } catch (err) {
    console.error(err);
    alert(err.message || "Error adding user");
  } finally {
    setLoading(false);
  }
};



const handleMId = (user) =>{
  setNMUId(user.id);
  setNaMUId(user.name);
  // alert(user.name);
}
const handleMName = (event) =>{
  setNMName(event.target.value);
}
const handleMLati = (event) =>{
  setNMLat(event.target.value);
}
const handleMLong = (event) =>{
  setNMlong(event.target.value);
}
const handleMType = (event) =>{
  if(event.target.value === 'Lite'){
    setBlshad(true);
  }else{
    setBlshad(false);
  }

  setNMType(event.target.value);
}
const handleCancelMac = () =>{
  setNMUId('');
  setNMName("");
  setNMLat("");
  setNMlong("");
  setMData('');
  setNMType('');
  setNaMUId("");
  setFormData({name: '', email: '', password: '', role: '',image: null,}) 
}

const handleMacSave = () => {
  if (
    nMName === '' || nMUId === '' || nMLat === '' || nMlong === '' ||
    mdata === '' || nMType === ''
  ) {
    alert("All fields are required from machine");
    return;
  }

  const data = {
    name: nMName,
    userId: nMUId,
    latitude: nMLat,
    longitude: nMlong,
    macId: selMacId,
    macType: nMType
  };
  // Determine endpoint based on macType
  const endpoint =
  nMType.toLowerCase() === "lite"
    ? "/api/createLiteMachine"
    : "/api/addMachine";

  fetch(endpoint, {
    credentials: "include",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then(response => response.json())
    .then(data => {
      alert(data.message);
      setNMUId('');
      setNMName('');
      setNMLat('');
      setNMlong('');
      setNMType('');
      setMData('');
      setNaMUId('');
      setFormData({
        name: '',
        email: '',
        password: '',
        role: '',
        image: null,
      });
      fetchMachines(); // Refresh list after saving
    })
    .catch(error => {
      console.error('Error:', error);
    });
};

const setMachineId = (e) => {
  // alert(e.id);

  if (!multipleSelection) {
      // console.log({ id, user_id });

      // Retrieve existing userData from sessionStorage
      let userData = sessionStorage.getItem('userData');
      
      userData = userData ? JSON.parse(userData) : {};

      // Replace selectedMachineIds with the new ID
      userData.selectedMachineIds = [e.id];
      userData.selectedName = [e.name]
      // Store the updated userData back in sessionStorage
      sessionStorage.setItem('userData', JSON.stringify(userData));
      navigate('/Dashboard');
      window.location.reload();
  }
}
const filteredMachines = machines.filter((machine) =>
  machine.name.toLowerCase().includes(searchTerm.toLowerCase())
);
const filteredUsers = allU.filter((user) =>
  user.name.toLowerCase().includes(searchTerm.toLowerCase())
);
const startIndex = (currentPage - 1) * rowsPerPage;
const currentMachines = filteredMachines.slice(startIndex, startIndex + rowsPerPage);
const currentusers = filteredUsers.slice(startIndex, startIndex + rowsPerPage)
const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
};

const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
    setShowIcon(event.target.value === '');
};
const totalPages = Math.ceil(filteredMachines.length / rowsPerPage);
const totalUpages = Math.ceil(filteredUsers.length / rowsPerPage);
const signOutFunc = async () => {
  try {
    await axios.post("/api/logout", {}, { withCredentials: true });
    sessionStorage.removeItem('userData');
    navigate('/'); 
    window.location.reload();
  } catch (error) {
    console.error("Error logging out:", error.response?.data || error.message);
  }
};

useEffect(() => {
  const fetchMachines = async () => {

    try {
    const response = await axios.get("/api/allMachines", {
      withCredentials: true,
    });
      setAllMachines(response.data);
    } catch (error) {
      console.error("Error fetching machines:", error);
    }
  };

  fetchMachines();
}, []);
const toggleDropdown = () => {
  setIsOpen(!isOpen);
  if (!isOpen) {
    resetState();
  }
};
const handleMouseEnter = (user) => {
  setHoveredItem(user.id);
  setSelUNM(user.name);
  const userMachines = allMachines.filter(
    (machine) => machine.user_id === user.id && machine.macType === "Full"
  );  

  if (userMachines.length > 0) {
    setSnglM(userMachines);
    setNoMachinesMessage("");
  } else {
    setSnglM([]);
    setNoMachinesMessage("User has no machines");
  }
};

const handleMouseLeave = () => {
  setHoveredItem(null);
  setSnglM([]);
  setNoMachinesMessage("");
};

const handleDef = (data) => {
  setIsOpen(!isOpen);
  setMData(data);
  setSelMacId(0);
};

const handleMachineClick2 = (machine) => {
  setMData(selUNM+" , "+machine.name);
  setSelMacId(machine.id);
  setIsOpen(false);
  setShowUsers(false);
};

const resetState = () => {
  setHoveredItem(null);
  setSnglM([]);
  setNoMachinesMessage("");
  setShowUsers(false);
};
const currMachine = (machine) => {
  if (machine) {
    setHoveredMachine(machine);
    setHoverMName(machine.name || 'Unknown');
    setHoverMId(machine.id || 'No ID');
    setHoverMUid(machine.user_id || 'No User ID');
  }
};
const fileInputRef = useRef(null);

const handleFileChange21 = (event) => {
  setSelectedFile(event.target.files[0]);
  handleUpload(event.target.files[0]);
};

const openFilePicker = () => {
  fileInputRef.current.click();
};

  // Function to fetch video names from the backend
  const fetchVideos = async () => {

    try {
      const response = await axios.get('/api/videos', {
        withCredentials: true,
      }); 
      setVideos(response.data);
      
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };
useEffect(() => {
  // Call fetchVideos initially and then every 15 seconds
  fetchVideos(); // Initial call
  const intervalId = setInterval(fetchVideos, 15000); // 15000 ms = 15 seconds

  // Clear interval on component unmount
  return () => clearInterval(intervalId);
}, []);
const handleVideoSelect = (video, name) => {
  // Pause all videos on the page (both components)
  setNowPName(name);
  const allVideos = document.querySelectorAll('video');
  allVideos.forEach((vid) => {
    vid.pause();
    vid.currentTime = 0; // Optional: Reset video to the beginning if needed
  });

  // Set the selected video
  if(superU === true){
    setSelectedVideo2(video);
  }else{
    setSelectedVideo(video);
  }
  
};


  const handleRightClick = (event, video) => {
    event.preventDefault();
    setSelectedVideo(video);
    setContextMenu({
      xPos: event.pageX,
      yPos: event.pageY,
    });
  };

  const handlePlay = () => {
    if (selectedVideo) handleVideoSelect(selectedVideo);
    setContextMenu(null);
  };

  const [hoveredVideoId, setHoveredVideoId] = useState(null);

  const handleDelete = async (video) => {
    // console.log(video.id, "This is video id to delete");
    try {
      await axios.delete(`/api/videosDelete/${video.id}`, {
        withCredentials: true,
      });
      setVideos(videos.filter((v) => v.id !== video.id));
    } catch (error) {
      console.error("Error deleting video:", error);
    }
  };
  const handleUpload = async (file) => {
    if (!file) {
      alert("Please select a video to upload.");
      return;
    }

    const formData = new FormData();
    formData.append('video', file);
    formData.append('videoName', file.name);

    // setIsLoading(true); // Show loading indicator
    try {
      const response = await axios.post('/api/upload-video', formData, {
        withCredentials: true,
        headers: { 
          'Content-Type': 'multipart/form-data', 
         },
        
      });
      if (response.data.success) {
        alert("Video uploaded successfully!");
        fetchVideos();
      } else {
        alert("Video upload failed.");
      }
    } catch (error) {
      console.error("Error uploading video:", error);
      alert("There was an error uploading the video.");
    } finally {
      // setIsLoading(false); // Hide loading indicator
    }
  };
  const closeContextMenu = () => setContextMenu(null);
  const toggleUsers = () =>{
    setShowUsers(true);
    // setIsOpen(!isOpen);
  }
  const closeDropAll = () => {
    setShowUsers(false);
    setIsOpen(false);
    setHoveredItem(null);
    setSnglM([]);
    setNoMachinesMessage("");
  }

const fetchSecureVideo = async (videoName) => {
  try {
    const res = await fetch(`/api/videos/${encodeURIComponent(videoName)}`, {
      credentials: "include", // ✅ Important for cookies
    });

    if (!res.ok) {
      console.error("Failed to fetch video:", res.statusText);
      return;
    }

    const blob = await res.blob();
    setVideoUrl(URL.createObjectURL(blob));
   // const url = URL.createObjectURL(blob);
   // setVideoUrl(url); // Assuming you have state for video URL
  } catch (err) {
    console.error("Error fetching video:", err);
  }
};


useEffect(() => {
  if (selectedVideo) {
    fetchSecureVideo(selectedVideo.name);
  }else if(selectedVideo2){
    fetchSecureVideo(selectedVideo2.name);
  }
}, [selectedVideo, selectedVideo2]);

// const fetchSecureThumbnail = async (videoName) => {
//   const res = await fetch(`/api/videos/${videoName}`, {
//     credentials: "include",
//   });

//   if (!res.ok) {
//     console.error("Failed to fetch video:", res.statusText);
//     return null;
//   }

//   const blob = await res.blob();
//   return URL.createObjectURL(blob);
// };
const fetchSecureThumbnail = async (videoName) => {
  try {
    const res = await fetch(`/api/videos/${encodeURIComponent(videoName)}`, {
      credentials: "include",
    });

    if (!res.ok) {
      console.error("Failed to fetch video:", res.status, videoName);
      return null;
    }

    const blob = await res.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Network error fetching thumbnail:", videoName, error);
    return null;
  }
};

// When loading list of videos, fetch their blob URLs for thumbnails
// useEffect(() => {
//   const loadThumbnails = async () => {
//     const urls = {};
//     for (const video of videos) {
//       const url = await fetchSecureThumbnail(video.name);
//       if (url) urls[video.name] = url;
//     }
//     setThumbnailUrls(urls);
//   };

//   if (videos?.length) loadThumbnails();
// }, [videos]);
// useEffect(() => {
//   let isMounted = true;

//   const loadThumbnails = async () => {
//     const urls = {};

//     for (const video of videos || []) {
//       const url = await fetchSecureThumbnail(video.name);
//       if (url && isMounted) {
//         urls[video.name] = url;
//       }
//     }

//     if (isMounted) setThumbnailUrls(urls);
//   };

//   if (videos?.length) loadThumbnails();

//   return () => {
//     isMounted = false;
//   };
// }, [videos]);
useEffect(() => {
  const loadThumbnails = async () => {
    const entries = await Promise.all(
      videos.map(async (video) => {
        const url = await fetchSecureThumbnail(video.name);
        return url ? [video.name, url] : null;
      })
    );

    setThumbnailUrls(Object.fromEntries(entries.filter(Boolean)));
  };

  if (videos?.length) loadThumbnails();
}, [videos]);

    return(
        <div className="full-detail" style={{height: `${classHeight}px`,width: `${classWidth }px`}}>
          <div className="usrs-shad" 
          style={{display: showUsers ? 'block' : 'none',
          height: `${classHeight}px`,width: `${classWidth }px`
          }}
          onClick={closeDropAll}
          ></div>
        <div className="sideBar currentSide">
        <div className="headSide mainDet">
                MAIN NAVIGATION
                </div>
        <div className="sidebtns" style={{display: superU ? 'none' : 'block'}}>
        <button className="ubtns"  onClick={turnDashboard}>User DashBoard</button>
        <button  className="ubtns" onClick={turnMachines} style={{color: uMachines ? '#EF7C32' : ''}}>User Machines</button>
        <button className="ubtns" onClick={turnMap} style={{color: uMap ? '#EF7C32' : ''}}>See on the map</button>
        <button className="ubtns" onClick={turnGide} style={{color: gide ? '#EF7C32' : '', display: superU ? 'none' : 'block'}}>Guide</button>
        <button className="ubtns" onClick={backSuperU} style={{display: supp ? 'block' : 'none'}}>Back</button>
        <button className='ubtns' onClick={signOutFunc} style={{display: supp ? 'none' : 'block'}}> Sign Out </button>
        </div>
        <div className="sidebtns" style={{display: superU ? 'block' : 'none'}}>
        <button className="ubtns" onClick={getUsers} style={{color: userList ? '#EF7C32': ''}}>Users</button>
        <button className="ubtns" onClick={addUser} style={{color: addUs ? '#EF7C32': ''}}>Add User</button>
        <button className="ubtns" onClick={addMachine} style={{color: aMach ? '#EF7C32': ''}}>Add Machine</button>
        <button className="ubtns" onClick={turnGide} style={{color: gide ? '#EF7C32' : ''}}>Guide</button>
        <button className='ubtns' onClick={signOutFunc} style={{display: supp ? 'block' : 'none'}}> Sign Out </button>
        
        </div>
        </div>
        <div className="mainDetails" style={{display: superU ? 'none' : 'block'}}>
      <div className="detailsUser">
                  <div className="mapMachine" style={{display: uMachines ? 'block' : 'none'}}>
                <div className="sp-recipes currentD">
                <div className="recipe-left" ></div>
                    <div className="full-details" >
                    <div className="details2 topDiv currentTop">
              <div className="same select-sp">
              <div>
                  Show
                  </div>
                  <div className="main-Select">
                        <select value={rowsPerPage} onChange={handleRowsPerPageChange} className="select-container">
                            <option value={5} className='options'>5</option>
                            <option value={10} className='options'>10</option>
                            <option value={15} className='options'>15</option>
                            <option value={20} className='options'>20</option>
                        </select>
                  </div>
                <div>
                Entries
                </div>
                  </div>
                  <div className="same">
                    <div className="same search-container">
                      <div className='triangle-container-sea'></div>
                      <div className="shadeTriangle-sea-crn"></div>
                <input
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="search-input"
                />
              <span className="search-icon" style={{ display: showIcon ? "block" : "none"}}>
                  <SearchIcon className="sp-icon" />
                </span>
              </div>
                </div>
          {multipleSelection ? (
          <div className="same btn-add" onClick={handleGoClick}> 
                    <button className='btnAdd'>
                    <div className="shadeTriangle-adbnt-crn"></div>
                  <div className="multiBtn">
                    Go
                    </div>
                    </button>
                  </div>
                    ) : (
                      <div className="same btn-add" onClick={() => setMultipleSelection(true)}> 
                    <button className='btnAdd'>
                    <div className="shadeTriangle-adbnt-crn"></div>
                  <div className="multiBtn">
                  Multiple Selection
                  </div>
                    </button>
                  </div>
                    )}
                    </div>
                    <div className="my-table currentTbl">
                        <table className="macTable customTable Dtbl" style={{height : Math.min(startIndex + rowsPerPage, filteredMachines.length) - startIndex < 10 ? `${(Math.min(startIndex + rowsPerPage, filteredMachines.length) - startIndex) * 9 +"%"}` : ``}} >
                            <thead>
                                <tr className="custom-row">
                                    {multipleSelection && <th>Select</th>}
                                    <th>S#</th>
                                    <th>Name</th>
                                    <th>Latitude</th>
                                    <th>Longitude</th>
                                </tr>
                            </thead>
                            <tbody className="macbod">
                                {currentMachines.map((machine, index) => (
                                    <tr
                                        key={machine.id}
                                        style={{ cursor: 'pointer', backgroundColor: selectedMachines.has(machine.id) ? '#e0e0e0' : 'white' }}
                                        onClick={(e) => handleMachineClick(machine.id,machine.name, e)}
                                        className="custom-row"
                                    >
                                        {multipleSelection && (
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedMachines.has(machine.id)}
                                                    onChange={() => handleCheckboxChange(machine.id, machine.name)}
                                                />
                                            </td>
                                        )}
                                        <td>{startIndex + index + 1}</td>
                                        <td>{`${machine.name} ${machine.macType === "Full" ? '' : '(lite)'}`}</td>
                                        <td>{machine.latitude}</td>
                                        <td>{machine.longitude}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className='bothDiv currentBot'>
                    <div className='bottomSh'>
                  <div className='results'>
                    Showing {startIndex + 1} to {Math.min(startIndex + rowsPerPage, filteredMachines.length)}
                  </div>
                  <div className='whiteClass'>
                    (Total {filteredMachines.length} entries)
                  </div>
                </div>
          <div className="pagination-info">
            <button className='constbtn'
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} 
                disabled={currentPage === 1}
            >
                Previous
            </button>
            {Array.from({ length: totalPages }, (_, i) => (
                <button 
                    key={i} 
                    onClick={() => setCurrentPage(i + 1)} 
                    disabled={currentPage === i + 1}
                className={`pbtn ${currentPage === i + 1? "active12" : ""}`}

                >
                    {i + 1}
                </button>
            ))}
            <button 
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} 
                disabled={currentPage === totalPages} className='constbtn'
            >
                Next
            </button>
        </div>
                    </div>
                </div>
            <div className="recipe-right"></div>
                  
                {/* </div> */}
                </div>
                  </div>
                    <div className="mapMachine setAll" style={{display: uMap ? 'block' : 'none'}}>
                      {/* <Map /> */}
                      <LoadScript googleMapsApiKey="AIzaSyBMsoFkZUHOq3sG9EI9jpTiwo7wEYMPPhk">
                <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={10}
          >
            {machines.map((machine) => (
              <Marker
                key={machine.id}
                position={{ lat: parseFloat(machine.latitude), lng: parseFloat(machine.longitude) }}
                onMouseOver={() => currMachine(machine)}
                onMouseOut={() => setHoveredMachine(null)}
                onClick={(e) => setMachineId(machine)}
              />
            ))}

            {hoveredMachine && hoverMName && hoverMId && hoverMUid && (
              <InfoWindow style={{backgroundColor:'transparent'}}
                position={{
                  lat: parseFloat(hoveredMachine.latitude)+0.030,
                  lng: parseFloat(hoveredMachine.longitude)
                }}
                onCloseClick={() => setHoveredMachine(null)}
              >
                  <div
              onClick={() => setMachineId(hoveredMachine)}
              className="hoverDiv">
                  <h2 className="hoverMM hMHM">{hoverMName}</h2>
                  <p className="hoverMM">ID: {hoverMId}</p>
                  {/* <p className="hoverMM">User ID: {hoverMUid}</p> */}
                </div>
              </InfoWindow>
            )}
          </GoogleMap>

              </LoadScript>
                      </div>
            <div className="mapMachine guide-div" style={{display: gide ? 'block' : 'none', padding: '1.5%'}}>
              {/* <div>You are in guide page</div> */}
              <div className="video-display">
                {videos.length > 0 ? (
                  <>
                  <div className="video-thumbnails">
                    {videos.map((video, index) => {
                      const videoNameWithoutExtension = video.name.split('.').slice(0, -1).join('.');

                      return (
                        <div key={index} className="video-item">
                          <video
                            src={thumbnailUrls[video.name]}
                            width="100%"
                            height="75%"
                            muted
                            autoPlay
                            loop
                            onClick={() => handleVideoSelect(video, videoNameWithoutExtension)}
                          />
                          <p onClick={() => handleVideoSelect(video, videoNameWithoutExtension)}>
                            {videoNameWithoutExtension}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                    {selectedVideo && (
                      <div className="selected-video-player">
                        <button className="close-button" onClick={() => setSelectedVideo(null)}>Back</button>
                        <p className="sl-vd-name">Now Playing: {nowPName}</p>
                        {videoUrl && (
                          <video
                            src={videoUrl}
                            style={{ width: "100%", height: "90%", padding: 0, margin: 0 }}
                            controls
                            autoPlay
                          />
                        )}
                      </div>
                    )}
                  </>
                  ) : (
                    <p>No videos available</p>
                )}
              </div>
            </div>
      </div>
        </div>
        <div className="mainDetails" style={{display: superU ? 'block' : 'none'}}>
        <div className="usersTable" style={{display: userList ? 'block' : 'none'}}>
        <div className="sp-recipes currentD">
        <div className="recipe-left" ></div>
            <div className="full-details" >
            <div className="details2 topDiv currentTop">
      <div className="same select-sp">
      <div>
          Show
          </div>
          <div className="main-Select">
                <select value={rowsPerPage} onChange={handleRowsPerPageChange} className="select-container">
                    <option value={5} className='options'>5</option>
                    <option value={10} className='options'>10</option>
                    <option value={15} className='options'>15</option>
                    <option value={20} className='options'>20</option>
                </select>
          </div>
        <div>
        Entries
        </div>
          </div>
          <h1>All Users</h1>
          <div className="same">
            <div className="same search-container">
              <div className='triangle-container-sea'></div>
              <div className="shadeTriangle-sea-crn"></div>
        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={handleSearchChange}
          className="search-input"
        />
      <span className="search-icon" style={{ display: showIcon ? "block" : "none"}}>
          <SearchIcon className="sp-icon" />
        </span>
      </div>
        </div>
            </div>
            <div className="my-table currentTbl">
                <table className="macTable customTable Dtbl" style={{height : Math.min(startIndex + rowsPerPage, filteredUsers.length) - startIndex < 10 ? `${(Math.min(startIndex + rowsPerPage, filteredUsers.length) - startIndex) * 9 +"%"}` : ``}} >
                    <thead>
                        <tr className="custom-row">
                            
                            <th>S#</th>
                            <th>Name</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody className="macbod">
                        {currentusers.map((user, index) => (
                            <tr
                                key={user.id}
                                onClick={(e) => getuserdetails(user)}
                                className="custom-row"
                            >
                                <td>{index + 1}</td>
                                <td>{user.name}</td>
                                <td>{user.email}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='bothDiv currentBot'>
            <div className='bottomSh'>
          <div className='results'>
            Showing {startIndex + 1} to {Math.min(startIndex + rowsPerPage, filteredUsers.length)}
          </div>
          <div className='whiteClass'>
            (Total {filteredUsers.length} entries)
          </div>
        </div>
  <div className="pagination-info">
    <button className='constbtn'
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} 
        disabled={currentPage === 1}
    >
        Previous
    </button>
    {Array.from({ length: totalUpages }, (_, i) => (
        <button 
            key={i} 
            onClick={() => setCurrentPage(i + 1)} 
            disabled={currentPage === i + 1}
        className={`pbtn ${currentPage === i + 1? "active12" : ""}`}

        >
            {i + 1}
        </button>
    ))}
    <button 
        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalUpages))} 
        disabled={currentPage === totalUpages} className='constbtn'
    >
        Next
    </button>
</div>
            </div>
        </div>
    <div className="recipe-right"></div>
          
        {/* </div> */}
        </div>
        </div>
                            {/* Add new User */}
        <div className="adduser" style={{display: addUs ? 'block' : 'none'}}> 
        <div className="machine">
        <div className="form-pump">
        {step === "FORM" && (
        <form className="form-pump" >
        <h2>Add New User</h2>
        <div className="inpt-cont inpt-cont-i inpt-cont-mac">
            <label>Name:</label>
            <div className='inpt inpt2 inpt2-i'>
            <div className="inptO"></div>
                <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
          </div>
            <div className="inpt-cont inpt-cont-i inpt-cont-mac">
            <label> Email: </label>
            <div className='inpt inpt2 inpt2-i'>
            <div className="inptO"></div>
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="pop-inpt"
                />
            <div className="inptC"></div>
            </div>
            </div>
            <div className="inpt-cont inpt-cont-i inpt-cont-mac">
            <label> Password: </label>
            <div className='inpt inpt2 inpt2-i'>
            <div className="inptO"></div>
                <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className="pop-inpt"
                />
            <div className="inptC"></div>
            </div>
            </div>
            <div className="inpt-cont inpt-cont-i inpt-cont-mac spec-aus">
            <div className="inptS">
            <label> Image: (2mb)(png, jpeg, jpg, webp)</label>
            <div className='inpt inpt2 inpt2-i jst-cntr'>
            <div className="inptO"></div>
              <input
                type="file"
                name="image"
                onChange={handleFileChange}
                accept="image/png, image/jpeg, image/jpg, image/webp"
              />
            <div className="inptC"></div>
            </div>
            </div>
            <div className="inptS">
            <label> Role: </label>
            <div className='inpt inpt2 inpt2-i'>
            <div className="inptO"></div>
                <select
                    name="role"
                    value={formData.role}
                    onChange={handleInputChange}
                  className="pop-inpt myselect"
                >
                    <option className='options'>--- Choose Role ---</option>
                    <option className='options' value="1">Super Admin</option>
                    <option className='options' value="2">Admin</option>
                </select>
            <div className="inptC"></div>
            </div>
            </div>
            </div>
            {/* <br /> */}
            <div className="pop-btn-sec macBtn uBtnSec">

              <div className="pop-btn2 ">
                <button onClick={handleSubmit} className=" btn-p2" disabled={loading}>
                <div className='triangle-container-popbtn'>
              </div>
              <div className="svIcon-n">
                <SIcon className='sp-icon' />
              </div>
                <div>
                  {step === "OTP" ? "Verify OTP" : "Save"}
                </div>
                </button>
              </div>
            </div>
        </form>
        )}
        {step === "OTP" && (
          <div className="adduser" style={{justifyContent: 'center', display: 'flex', flexDirection: 'column'}}>
          <div className="inpt-cont inpt-cont-i inpt-cont-mac">
            <label>Enter OTP:</label>
            <div className='inpt inpt2 inpt2-i'>
              <div className="inptO"></div>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                className="pop-inpt"
                placeholder="6-digit OTP"
              />
              <div className="inptC"></div>
            </div>
            </div>
            <div className="pop-btn-sec macBtn uBtnSec">

              <div className="pop-btn2 ">
                <button onClick={handleSubmit} className=" btn-p2" style={{display: 'flex', justifyContent: 'center'}} disabled={loading}>
                  {step === "OTP" ? "Verify OTP" : "Save"}
                </button>
              </div>
            </div>
            </div>
          )}
        </div>
        </div>
        </div>
                            {/* Add new Machine */}
        <div className="addmachine" style={{display:  aMach ? 'block' : 'none', position: 'relative' }}>
        <div className="machine">
          <div className="form-pump">
            <h2 className='headIngre'>Add New Machine</h2>
            <div className="inpt-cont inpt-cont-i inpt-cont-mac">
              <label>User Name:</label>
              <div className='inpt inpt2 inpt2-i'>
              <div className="inptO sp-oc"></div>
                <select value={naMUId}   onChange={(e) => {
                  const selectedUser = allU.find(user => user.name === e.target.value);
                  handleMId(selectedUser);
                }} className="pop-inpt macName">
                  <option className='options'>--Choose User--</option>
                  {allU.map((user) => (
                    <option className='options' key={user.unique_id} id={user.id} value={user.name}>
                      {user.name}
                    </option>
                  ))}
                </select>
              <div className="inptC sp-oc"></div>
              </div>
            </div>
            <div className="inpt-cont inpt-cont-i inpt-cont-mac">
              <label> Machine Name:</label>
              <div className='inpt inpt2 inpt2-i'>
              <div className="inptO"></div>
                <input
                  type="text"
                  value={nMName}
                  onChange={handleMName}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont inpt-cont-i inpt-cont-mac spec-aus">
            <div className="inptS">
            <label>Latitude:</label>
              <div className='inpt inpt2 inpt2-i'>
              <div className="inptO"></div>
                <input
                  type="number"
                  value={nMLat}
                  onChange={handleMLati}
		  onWheel={(e) => e.currentTarget.blur()}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="inptS">
            <label>Longitude:</label>
              <div className='inpt inpt2 inpt2-i'>
              <div className="inptO"></div>
                <input
                  type="number"
                  value={nMlong}
                  onChange={handleMLong}
                  onWheel={(e) => e.currentTarget.blur()}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            </div>
            <div className="inpt-cont inpt-cont-i inpt-cont-mac spec-aus">
            <div className="inptS">
            <label>Machine Type</label>
              <div className='inpt inpt2 inpt2-i'>
              <div className="inptO"></div>
                <select
                      name="role"
                      value={nMType}
                      onChange={handleMType}
                    className="pop-inpt myselect"
                  >
                      <option className='options'>--- Choose Type ---</option>
                      <option className='options' value="Full">Cocktail Machine</option>
                      <option className='options' value="Lite">Cocktail Machine (lite)</option>
                  </select>
              <div className="inptC"></div>
              </div>
            </div>
            <div className="inptS">
            <label>Machine Data:</label>
              <div className='inpt inpt2 inpt2-i setRel'>
                  {/* <div className="setShad" style={{display: blshad ? 'block' : 'none'}}></div> */}
                <div className="inptO sp-oc"></div>
                <div className="dropdown pop-inpt">
                  <button onClick={toggleDropdown} className="dropdown-button">
                    <div>{mdata === "" ? "---Choose Machine Data---" : mdata}</div>
                    <div className="dwArr">&#9662;</div>
                  </button>
                  {isOpen && (
                    <ul className="dropdown-list">
                      <li
                        className="dropdown-item options"
                        onClick={() => handleDef("Default Data")}
                      >
                        Default Data
                      </li>
                      <li
                        className="dropdown-item options"
                        style={{display: blshad ? 'none' : ''}}
                      >
                        <div className="multi-class" onClick={toggleUsers}>
                          <div>Copy Data From Other Machine</div>
                          <div className="rwArr">&#9656;</div>
                        </div>
                        {showUsers && (
                          <ul className="dropdown-sublist users-list">
                            {users.map((user) => (
                              <li
                                className="options"
                                key={user.id}
                                onClick={() => handleMouseEnter(user)}
                              >
                                {user.name}
                                
                              </li>
                            ))}
                          </ul>
                        )}
                        {hoveredItem != null && (
                    <ul className="machines-list" 
                    style={{display: hoveredItem === null ? 'none' : 'block'}}
                    >
                      {snglM.length > 0 ? (
                        snglM.map((machine) => (
                          <li
                            key={machine.id}
                            className="options user-sub-machines"
                            onClick={() => handleMachineClick2(machine)}
                          >
                            {machine.name}
                          </li>
                        ))
                      ) : (
                        <li className="no-machines options">
                          {noMachinesMessage}
                        </li>
                      )}
                    </ul>
                  )}
                      </li>
                      
                    </ul>
                    
                  )}
                  
                </div>
              <div className="inptC sp-oc"></div>
              </div>
            </div>
            </div>
            <div className="pop-btn-sec macBtn">
              <div className="pop-btn2 btn266">
                <button onClick={handleCancelMac} className="btn-p2">
                <div className='triangle-container-popbtn'>
                {/* <div className=" shadeTriangle-popbtn2"></div> */}
              </div>
              <div className="canIcon">
                <ClIcon className='sp-icon' />
              </div>
              <div>
              Reset
              </div>
                  
                </button>
              </div>
              <div className="pop-btn2 ">
                <button onClick={handleMacSave} className=" btn-p2">
                <div className='triangle-container-popbtn'>
                {/* <div className=" shadeTriangle-popbtn2"></div> */}
              </div>
              <div className="svIcon-n">
                <SIcon className='sp-icon' />
              </div>
                <div>
                  Save
                </div>
                </button>
              </div>
            </div>
          </div>
          </div>
        </div>
            <div className="mapMachine guide-div" style={{display: gide ? 'block' : 'none', padding: '1.5%'}}>
            <div className="video-display">
  {videos.length > 0 ? (
    <>
    <div className="video-thumbnails">
      {videos.map((video, index) => {
        const videoNameWithoutExtension = video.name.split('.').slice(0, -1).join('.');

        return (
          <div
            key={index}
            className="video-item"
            onMouseEnter={() => setHoveredVideoId(video.id)}   // set on hover
            onMouseLeave={() => setHoveredVideoId(null)}       // clear when leaving
          >
            <video
              src={thumbnailUrls[video.name]}
              width="100%"
              height="75%"
              muted
              autoPlay
              loop
              onClick={() => handleVideoSelect(video, videoNameWithoutExtension)}
            />
            <p onClick={() => handleVideoSelect(video, videoNameWithoutExtension)}>
              {videoNameWithoutExtension}
            </p>
            {hoveredVideoId === video.id && (
              <div className="video-controls">
                <button onClick={() => handleVideoSelect(video, videoNameWithoutExtension)}>Play</button>
                <button onClick={() => handleDelete(video)}>Delete</button>
              </div>
            )}
          </div>
        );
      })}
      {/* Upload Video Button at the end of the list */}
        <div className="video-item">
          <input
            type="file"
            accept="video/mp4,video/webm,video/ogg,video/quicktime"
            onChange={handleFileChange21}
            ref={fileInputRef}
            style={{ display: "none" }}
          />
          <button onClick={openFilePicker} className="up-btn">
            <div className="up-btn-triangle"></div> {/* Shaded background */}
            Upload Video
          </button>
        </div>
    </div>
      {selectedVideo2 && (
        <div className="selected-video-player">
          <button className="close-button" onClick={() => setSelectedVideo2(null)}>
            Back
          </button>
          <p className="sl-vd-name">Now Playing: {nowPName}</p>
          {videoUrl && (
            <video
              src={videoUrl}
              style={{ width: "100%", height: "90%", padding: 0, margin: 0 }}
              controls
              autoPlay
            />
          )}
        </div>
      )}
    </>
  ) : (
    <>
      <p>No videos available</p>
      <div className="video-item">
        <input
          type="file"
          accept="video/mp4,video/webm,video/ogg,video/quicktime"
          onChange={handleFileChange21}
          ref={fileInputRef}
          style={{ display: "none" }}
        />

        <button onClick={openFilePicker} className="up-btn">
          <div className="up-btnTriangle-sea2"></div>
          Upload Video
        </button>
      </div>
    </>
  )}
</div>
          </div>
        </div>
        </div>
    )
}



export default Details;
